import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "analyses-lpu-cards-not-found d-flex flex-column align-center justify-center text-center px-4 rounded-xl bg-gray-0 elevation-1",
      attrs: { "data-qa": "analyses_lpu_cards_not_found" },
    },
    [
      _c(VImg, {
        staticClass: "analyses-lpu-cards-not-found__image mb-6 flex-grow-0",
        attrs: {
          src: _setup.imageSrc,
          alt: "",
          width: "300",
          height: "250",
          contain: "",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-h5 text--text mb-4" }, [
        _vm._v("\n    Ничего не нашлось\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text--text" }, [
        _vm._v("\n    Попробуйте изменить параметры поиска.\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }